import { PaginationSettings } from 'src/types/quasar';

export default class PaginationHelper {
  static BasePaginationSettings(): PaginationSettings {
    return {
      sortBy: '',
      rowsPerPage: 10,
      rowsNumber: 0,
      page: 1,
      descending: false,
    };
  }

  static RowsPerPageOptions(): Array<number> {
    return [10, 20, 30];
  }

  static BasePaginationMobileSettings(): PaginationSettings {
    if (screen.width <= 1439 && screen.width > 1023) {
      return {
        sortBy: '',
        rowsPerPage: 6,
        rowsNumber: 0,
        page: 1,
        descending: false,
      };
    } else if (screen.width <= 1023 && screen.width > 599) {
      return {
        sortBy: '',
        rowsPerPage: 4,
        rowsNumber: 0,
        page: 1,
        descending: false,
      };
    } else if (screen.width <= 599) {
      return {
        sortBy: '',
        rowsPerPage: 10,
        rowsNumber: 0,
        page: 1,
        descending: false,
      };
    } else {
      return {
        sortBy: '',
        rowsPerPage: 10,
        rowsNumber: 0,
        page: 1,
        descending: false,
      };
    }
  }

  static RowsPerPageMobileOptions(): Array<number> {
    if (screen.width <= 1439 && screen.width > 1023) {
      return [6, 9, 12, 15];
    } else if (screen.width <= 1023 && screen.width > 599) {
      return [4, 6, 8, 10];
    } else if (screen.width <= 599) {
      return [10, 20, 30];
    } else {
      return [10, 20, 30];
    }
  }
}
